import { useNavigate } from "react-router-dom";
import { ArrowLeft } from "lucide-react";

export default function PrivacyPolicy() {
  const navigate = useNavigate();
  return (
    <div className="max-w-2xl mx-auto px-5 py-8 space-y-6 text-slate-700">
      <button onClick={() => navigate(-1)} className="flex items-center gap-1.5 text-sm text-slate-500 hover:text-[#0F172A] transition-colors mb-2" data-testid="back-btn">
        <ArrowLeft className="w-4 h-4" /> Indietro
      </button>
      <h1 className="font-heading text-3xl font-bold text-[#0F172A]">Privacy Policy</h1>
      <p className="text-sm text-slate-400">Ultimo aggiornamento: marzo 2026</p>

      <section className="space-y-2">
        <h2 className="font-semibold text-lg text-[#0F172A]">1. Titolare del trattamento</h2>
        <p className="text-sm leading-relaxed">
          Il presente sito è gestito da venditoreElite a uso personale e professionale degli agenti di commercio.
          Per qualsiasi informazione relativa al trattamento dei dati, puoi contattarci alla pagina{" "}
          <a href="/contatti" className="text-blue-600 hover:underline">Contatti</a>.
        </p>
      </section>

      <section className="space-y-2">
        <h2 className="font-semibold text-lg text-[#0F172A]">2. Dati raccolti</h2>
        <p className="text-sm leading-relaxed">
          L'applicazione raccoglie e memorizza esclusivamente i dati inseriti dall'utente (clienti,
          appuntamenti, note) su database privato. Non vengono raccolti dati personali di terzi senza
          consenso esplicito.
        </p>
        <p className="text-sm leading-relaxed">
          Tramite Google AdSense potrebbero essere raccolti dati di navigazione (cookie, indirizzo IP,
          identificatori dispositivo) a fini pubblicitari. Per maggiori informazioni consulta la{" "}
          <a href="https://policies.google.com/privacy" target="_blank" rel="noreferrer" className="text-blue-600 hover:underline">
            Privacy Policy di Google
          </a>.
        </p>
      </section>

      <section className="space-y-2">
        <h2 className="font-semibold text-lg text-[#0F172A]">3. Cookie</h2>
        <p className="text-sm leading-relaxed">
          Questo sito utilizza cookie tecnici necessari al funzionamento e cookie di terze parti (Google
          AdSense) a fini pubblicitari. Per dettagli consulta la nostra{" "}
          <a href="/cookie-policy" className="text-blue-600 hover:underline">Cookie Policy</a>.
        </p>
      </section>

      <section className="space-y-2">
        <h2 className="font-semibold text-lg text-[#0F172A]">4. Base giuridica</h2>
        <p className="text-sm leading-relaxed">
          Il trattamento dei dati avviene sulla base del legittimo interesse del titolare e, per i cookie
          pubblicitari, previo consenso dell'utente ai sensi del GDPR (Reg. UE 2016/679).
        </p>
      </section>

      <section className="space-y-2">
        <h2 className="font-semibold text-lg text-[#0F172A]">5. Diritti dell'utente</h2>
        <p className="text-sm leading-relaxed">
          Hai il diritto di accedere, rettificare, cancellare i tuoi dati e di opporti al trattamento.
          Per esercitare tali diritti contattaci tramite la pagina{" "}
          <a href="/contatti" className="text-blue-600 hover:underline">Contatti</a>.
        </p>
      </section>

      <section className="space-y-2">
        <h2 className="font-semibold text-lg text-[#0F172A]">6. Conservazione dei dati</h2>
        <p className="text-sm leading-relaxed">
          I dati inseriti nell'applicazione sono conservati fino a cancellazione da parte dell'utente.
          I dati relativi ai cookie pubblicitari seguono le politiche di Google.
        </p>
      </section>

      {/* ── Sezione B2B ─────────────────────────────────────────────── */}
      <div className="border-t-2 border-[#0F172A]/10 pt-6">
        <div className="inline-block bg-[#0F172A] text-white text-xs font-bold px-3 py-1 rounded-full mb-4 uppercase tracking-wider">
          Sezione Aziende — Versione Business
        </div>

        <section className="space-y-2">
          <h2 className="font-semibold text-lg text-[#0F172A]">7. Trattamento dei dati per conto delle aziende</h2>
          <p className="text-sm leading-relaxed">
            Nell'ambito della versione <strong>Business</strong> di venditoreElite, le aziende (di seguito "Azienda")
            possono creare account per i propri agenti di commercio e caricare nella piattaforma dati relativi
            ai propri clienti e alle proprie attività commerciali.
          </p>
          <p className="text-sm leading-relaxed">
            In tal caso, <strong>l'Azienda è l'unica Titolare del trattamento</strong> dei dati che carica
            sulla piattaforma (anagrafiche clienti, appuntamenti, ordini, ecc.), ai sensi dell'art. 4, n. 7,
            del GDPR (Reg. UE 2016/679). L'Azienda è responsabile di aver acquisito le necessarie basi
            giuridiche per trattare tali dati e per aver informato i propri interessati.
          </p>
          <p className="text-sm leading-relaxed">
            <strong>venditoreElite agisce esclusivamente come Responsabile del trattamento</strong> ai sensi
            dell'art. 4, n. 8, e dell'art. 28 del GDPR, limitandosi a trattare i dati per conto e su
            istruzione dell'Azienda, al solo fine di erogare il servizio richiesto.
          </p>
        </section>

        <section className="space-y-2 mt-4">
          <h2 className="font-semibold text-lg text-[#0F172A]">8. Accordo sul trattamento dei dati (DPA)</h2>
          <p className="text-sm leading-relaxed">
            Le aziende che utilizzano la versione Business di venditoreElite possono richiedere la firma di
            un Accordo sul Trattamento dei Dati (Data Processing Agreement – DPA) conforme all'art. 28 del
            GDPR. Per richiedere il DPA, contattare venditoreElite tramite la pagina{" "}
            <a href="/contatti" className="text-blue-600 hover:underline">Contatti</a>.
          </p>
        </section>

        <section className="space-y-2 mt-4">
          <h2 className="font-semibold text-lg text-[#0F172A]">9. Misure di sicurezza</h2>
          <p className="text-sm leading-relaxed">
            venditoreElite adotta misure tecniche e organizzative adeguate per proteggere i dati trattati
            per conto delle Aziende, incluse connessioni crittografate (HTTPS), isolamento dei dati per
            account e accesso controllato tramite credenziali nominative.
          </p>
        </section>

        <section className="space-y-2 mt-4">
          <h2 className="font-semibold text-lg text-[#0F172A]">10. Sub-responsabili del trattamento</h2>
          <p className="text-sm leading-relaxed">
            Per l'erogazione del servizio, venditoreElite si avvale di fornitori terzi (hosting, database
            cloud) che operano come sub-responsabili del trattamento nel rispetto del GDPR. L'elenco dei
            sub-responsabili è disponibile su richiesta.
          </p>
        </section>
      </div>
    </div>
  );
}
